module.exports = __webpack_public_path__ + "media/src/images/icons/attach-3ccdd3b354082ca00b199c1162ee72a7.svg";